import { useEffect, useRef, useState } from 'react';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/StoreContext';
import { Toast } from '@/components/ui/Toast';
import { LettersBanner } from './LettersBanner';
import { Timer } from './Timer';
import { WordInput } from './WordInput';
import { WordsList } from './WordsList';
import { OpponentProgress } from './OpponentProgress';
import styles from './RoundView.module.css';

export const RoundView = observer(function RoundView() {
  const { round, room } = useStore();
  const [leftToast, setLeftToast] = useState<{ name: string; key: number } | null>(null);
  const prevConnected = useRef<Map<string, boolean>>(new Map());

  useEffect(() => {
    round.opponents.forEach(o => prevConnected.current.set(o.playerId, o.isConnected));

    return reaction(
      () => round.opponents.map(o => ({ id: o.playerId, name: o.nickname, connected: o.isConnected })),
      (opps) => {
        for (const o of opps) {
          const was = prevConnected.current.get(o.id);
          if ((was === undefined || was) && !o.connected) {
            setLeftToast({ name: o.name, key: Date.now() });
          }
          prevConnected.current.set(o.id, o.connected);
        }
      }
    );
  }, []);

  if (!round.letters) return null;

  const solo = room.room
    ? room.room.settings.mode === 'Solo'
    : round.opponents.length === 0;

  const kicker = solo
    ? 'Тренировка'
    : round.totalRounds > 1
      ? `Раунд ${round.roundIndex + 1} / ${round.totalRounds}`
      : 'Один раунд';

  const showOpponents = !solo && round.opponents.length > 0;

  return (
    <div className={styles.screen}>
      <div className={styles.header}>
        <span className={styles.kicker}>{kicker}</span>
        <Timer />
      </div>
      <LettersBanner letters={round.letters} size="lg" />
      {showOpponents && <OpponentProgress />}
      <div className={styles.scrollArea}>
        <WordsList />
      </div>
      <WordInput />
      {leftToast && (
        <Toast
          key={leftToast.key}
          open
          onOpenChange={(open) => { if (!open) setLeftToast(null); }}
          title={`${leftToast.name} покинул игру`}
          variant="warning"
          duration={3000}
        />
      )}
    </div>
  );
});
